/**
 * What crosses the wire between the API and the web app.
 *
 * Note what is NOT here. A clip's public face carries no decoded text of any
 * kind and no other copier's work - only the audio and enough context to
 * choose a clip. Copies must be blind to be worth anything: a copier primed
 * with a decoder's reading, or with someone else's copy, produces a reference
 * that agrees with its source by construction (CORPUS.md section 3a). The
 * exact frequency and start time stay private for the same reason: they are
 * all anyone needs to look a callsign up instead of copying it.
 */
export const METHODS = ['ear', 'ear+decoder', 'decoder'];
export const CONFIDENCES = ['high', 'medium', 'low'];
export const MAX_NOTES_CHARS = 2000;
export const MAX_DECODER_CHARS = 80;
//# sourceMappingURL=api-types.js.map